@if (showShell()) {
  <app-navbar></app-navbar>
}
<ngx-spinner type="square-jelly-box"></ngx-spinner>
<router-outlet></router-outlet>
@if (showShell()) {
  <app-footer></app-footer>
}
<app-cookie-banner></app-cookie-banner>